// src/components/Brain.js

import React, { Suspense, useRef } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { OrbitControls, useGLTF } from '@react-three/drei';

// --- THIS IS THE FINAL, CORRECT IMPORT ---
import { useSpring, animated } from '@react-spring/three';

// Model component remains the same
function Model(props) {
  const { scene } = useGLTF('/brain.glb'); 
  return <primitive object={scene} {...props} />;
}

// This component handles the entrance and idle animations
function AnimatedBrainModel() {
  const modelRef = useRef();

  // Define the spring animation for the entrance
  const springProps = useSpring({
    from: { 
      scale: [0, 0, 0],
      rotation: [0, -Math.PI, 0]
    },
    to: { 
      scale: [2.8, 2.8, 2.8],
      rotation: [0, 0, 0]
    },
    config: { mass: 4, tension: 120, friction: 40 },
    delay: 500
  });

  // The continuous idle rotation
  useFrame(() => {
    if (modelRef.current) {
      modelRef.current.rotation.y += 0.003; 
    }
  });

  return (
    <animated.group 
      ref={modelRef}
      scale={springProps.scale}
      rotation={springProps.rotation}
    >
      <Model />
    </animated.group>
  );
}


export default function Brain() {
  return (
    <Suspense fallback={null}>
      <Canvas camera={{ position: [0, 0, 12], fov: 25 }}>
        <ambientLight intensity={1.5} color={"#7DF9FF"} /> 
        <directionalLight position={[3, 2, 5]} intensity={3} color={"#A020F0"} /> 
        
        <AnimatedBrainModel />

        <OrbitControls enableZoom={true} enablePan={false} autoRotate={false} />
      </Canvas>
    </Suspense>
  );
}